// extracted by css-extract-rspack-plugin
module.exports =  {"root":"InventoryViewer__root___RJ4E9","filterText":"InventoryViewer__filterText___oYnGU"};